/**
 * ч.958 (рішення власника, дизайн зі скріна): кнопка користувача у хідері —
 * КОЛО З ІНІЦІАЛАМИ + імʼя і роль у два рядки. Клік веде на сторінку
 * «Облікового запису» (/account), а не відкриває попап: профіль став
 * повноцінною сторінкою з розділами.
 *
 * Якщо ПІБ не заповнено — ініціали і підпис беремо з email (рішення власника).
 */
import { useNavigate } from 'react-router-dom';
import { tenantRoleLabel } from '@/auth/roleLabels';

export interface MeLike {
  id: string;
  full_name?: string | null;
  email?: string | null;
  tenant_role?: string | null;
}

/** «Коваленко Дмитро» → «КД»; без ПІБ — перші дві літери email. */
export function userInitials(me: MeLike): string {
  const name = (me.full_name ?? '').trim();
  if (name) {
    const parts = name.split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] ?? '';
    const second = parts[1]?.[0] ?? '';
    return (first + second).toUpperCase() || first.toUpperCase();
  }
  const local = (me.email ?? '').split('@')[0] ?? '';
  return local.slice(0, 2).toUpperCase() || '—';
}

/** «Коваленко Дмитро» → «Коваленко Д.»; без ПІБ — email (як просив власник). */
export function userShortName(me: MeLike): string {
  const name = (me.full_name ?? '').trim();
  if (!name) return me.email ?? '—';
  const [last, first] = name.split(/\s+/).filter(Boolean);
  return first ? `${last} ${first[0]!.toUpperCase()}.` : (last ?? name);
}

export default function UserMenu({ me }: { me: MeLike | undefined }) {
  const navigate = useNavigate();
  if (!me) return null;
  // ч.1072: роль в АКАУНТІ («Власник акаунта»), а не «власник бізнесу».
  const role = tenantRoleLabel(me.tenant_role);
  return (
    <button type="button" className="app__user" onClick={() => navigate('/account')}
      title={`Обліковий запис: ${userShortName(me)}${role ? `, ${role}` : ''}`}>
      <span className="app__user-avatar" aria-hidden>{userInitials(me)}</span>
      <span className="app__user-text">
        <span className="app__user-name">{userShortName(me)}</span>
        {role && <span className="app__user-role">{role}</span>}
      </span>
      <span className="app__user-caret" aria-hidden>⌄</span>
    </button>
  );
}
